<template>
    <div class="col-12 mb-4" v-if="escorts">
        <div class="container-box">
            <div class="container-box-title">{{user.venue_section_title || translate.account.girlsAtThisVenue}}</div>
            <div class="container-box-content" id="profile-page-venue-escorts">
                <div class="row profile-block-wrap">
                    <regular-escort-view v-for="(escort, index) in escorts"
                                         :class="{'d-none d-md-block': index >= mobileVisibleCount && !showRestOnMobile}"
                                         :key="escort.id + escort.username"
                                         :is-simplified="true"
                                         :user-prop="escort">
                    </regular-escort-view>
                </div>
                <div class="d-md-none text-center" v-if="escorts.length > mobileVisibleCount && !showRestOnMobile">
                    <u class="btn btn-rebrand-grey-outline btn-rebrand-xs w-full mt-2"
                       @click="showRestOnMobile = true">
                        {{ translate.account.viewAll }}
                    </u>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import lazyLoadImg from "@/components/mixins/lazyLoadImg";
import RegularEscortViewComponent from "@/components/search/partials/RegularEscortViewComponent";

const data = () => {
    return {
        showRestOnMobile: false,
        mobileVisibleCount: 4,
    }
};

export default {
    data,
    mounted() {
        this.initLazyLoading();
    },
    mixins: [
        lazyLoadImg,
    ],
    methods: {},
    computed: {
        ...mapState([
            'translate'
        ]),
    },
    props: {
        escorts: {
            type: Array,
            default: []
        },
        user: {
            type: Object,
            default: {}
        },
    },
    components: {
        'regular-escort-view': RegularEscortViewComponent,
    }
}
</script>
